import '../scss/main.scss';
import $ from 'jquery';
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

import { _GLOBALS } from './globals.js';
import { initBootstrap } from "./bootstrap.js";
import { Modal, Toast } from 'bootstrap';
import { Router } from './Router.js';
import { Modals } from './Helper.js';
import { detectWallets } from './ak_js_stuff/detectWallet.js';
import { connectWallet } from './ak_js_stuff/useWallet.js';
import { walletEvents } from './ak_js_stuff/walletEvents.js';
import { logit } from './ak_js_stuff/simpleLog.js';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
// Add icons to the library
library.add(faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion);

// Automatically replace <i> tags with SVG
dom.watch();

// Loading bootstrap with optional features
initBootstrap({
    tooltip: true,
    popover: true,
    toasts: true,
});

let modalElement = null;
let modalInstance = null;
let _WALLETS = null;

$(document).ready(async function () {
    console.log(`Plugin loaded DEBUG =`, _GLOBALS.DebugMode);

    initGoogleAnalytics();
    checkQueryParams();
    //checkDarkMode();
    registerEvents();

    _WALLETS = await detectWallets();
    if (_GLOBALS.DebugMode) console.log("Wallets", _WALLETS);
    if (_GLOBALS.DebugMode) logit("Wallets", _WALLETS);

//    _GLOBALS.GA.page();

    // Called by Mobile
    const currentWallet = getCurrentAppWallet(_WALLETS);
    if (currentWallet) {
        
        try {
            const pubkey = await connectWallet(currentWallet);

            // Referral Program URL called
            if (_GLOBALS.ReferralProgramModule) {
                _GLOBALS.GA.track('referralManager', {
                    page: 'Wallet Selection'
                });

                Router.To('referral_config', { wallet: currentWallet, pubkey: pubkey });
            }
            // Normal payment URL called
            else {
                _GLOBALS.GA.track('paymentManager', {
                    page: 'Wallet Selection'
                });
                Router.To('payment', { wallet: currentWallet, pubkey: pubkey });
            }
            return;
        } catch (err) {
            if (_GLOBALS.DebugMode) {
                console.log('connectWallet() Error type:', err.name);    // Type of error (e.g., TypeError)
                console.log('connectWallet() Error message:', err.message); // Message describing the error
                console.log('connectWallet() Error stack:', err.stack);     // Stack trace (useful for debugging)
                console.log("Typeof error", typeof err);
            }
            if (err.name === 'WalletConnectError') {
                _GLOBALS.GA.track('walletConnectError', {
                    page: 'Wallet Selection',
                    data: 'no_account_selected'
                });
                Modals.DefaultWarning('No account selected', 'Please connect your wallet and select an account');
            } else {
                _GLOBALS.GA.track('default_error', {
                    page: 'Wallet Selection',
                    data: 'no_account_selected'
                });
                Modals.DefaultWarning('An error occured', err.message);
            }

            routeToWalletSelection();
            return;
        }
        routeToWalletSelection();

        return;
    }
    // Called by Desktop
    routeToWalletSelection();

    //    const testWallet = {
    //        "name": "Phantom",
    //        "icon": "/phantom_wallet.svg",
    //        "detected": true,
    //        "inAppBrowser": false
    //    };
    //    const pubkey = 'BHjFqH9grPBvXvuNxQUhQ1j7yLFctsb85gctT8EyWnUa';
    //    Router.To('payment', {wallet:testWallet, pubkey: pubkey});
    //    Router.To('referral_config', {wallet:_WALLETS[0], pubkey:pubkey});
});

const initGoogleAnalytics = () => {
    const analytics = Analytics({
        app: 'equichain-payment-gateway',
        plugins: [
          googleAnalytics({
            measurementIds: [_GLOBALS.GoogleID],
            debug: _GLOBALS.DebugMode
          })
        ]
    })
    _GLOBALS.GA = analytics;
}
const getCurrentAppWallet = (wallets) => {
    return wallets.find(wallet => wallet.detected && wallet.inAppBrowser) || null;
}

const routeToWalletSelection = () => {
    if (_GLOBALS.ReferralProgramModule) {
        _GLOBALS.GA.track('referralManager', {
            page: 'Wallet Selection'
        });
        Router.To('walletSelection', { wallets: _WALLETS }, 'referral_config');
    } else {
        _GLOBALS.GA.track('paymentManager', {
            page: 'Wallet Selection'
        });
        Router.To('walletSelection', { wallets: _WALLETS });
    }
}

const checkQueryParams = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    //const referralProgramModule = urlParams.get('rp') === '1';
    //_GLOBALS.ReferralProgramModule = referralProgramModule || false;
    // Check if the current domain is "referral.equichain.org"
    const isAffiliateDomain = window.location.hostname === "referral.equichain.org";
    // Set ReferralProgramModule based on the domain or "rp=1" query param
    const referralProgramModule = urlParams.get('rp') === '1' || isAffiliateDomain;
    _GLOBALS.ReferralProgramModule = referralProgramModule || false;

    const referralProgram = urlParams.get('ref') || "";
    _GLOBALS.ReferralProgramActive = referralProgram?.length > 0 || false;
    _GLOBALS.ReferralProgram = referralProgram;
}

const checkDarkMode = () => {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // Initial Check
    if (darkModeMediaQuery.matches) {
        $("body").attr('data-bs-theme', 'dark');
    } else {
        $("body").attr('data-bs-theme', 'light');
    }

    // Listen for changes
    darkModeMediaQuery.addEventListener("change", function (event) {
        if (event.matches) {
            $("body").attr('data-bs-theme', 'dark');
        } else {
            $("body").attr('data-bs-theme', 'light');
        }
    });
}

const registerEvents = () => {
    window.addEventListener("load", async () => {
        // Listen for wallet events
        walletEvents.on("wallet:connecting", (event) => {
            if (_GLOBALS.DebugMode) logit("Wallet is connecting:", event.detail);
        });

        walletEvents.on("wallet:connected", (event) => {
            if (_GLOBALS.DebugMode) logit("Wallet connected successfully:", event.detail);
        });

        walletEvents.on("wallet:connectionFailed", (event) => {
            if (_GLOBALS.DebugMode) logit("Wallet connection failed:", event.detail);
        });

    });
}